module.exports = __webpack_public_path__ + "786c2bb764f255e7deda291a1403b050.MP3";